import { useCtx } from "@reatom/npm-react";
import { updateFromSource, urlAtom } from "@reatom/url";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

// NOTE: docs url https://v3.reatom.dev/package/url/#integrations
export const useRouterSync = () => {
  const ctx = useCtx();
  const setupRef = React.useRef(false);

  // subscribe to location changes
  const location = useLocation();
  const href = new URL(
    location.pathname + location.search + location.hash,
    globalThis.location.origin,
  ).href;

  const navigate = useNavigate();
  if (!setupRef.current) {
    setupRef.current = true;
    urlAtom.settingsAtom(ctx, {
      init: () => new URL(href),
      sync: (_ctx, url, replace) =>
        navigate(url.pathname + url.search, { replace }),
    });
  }

  if (ctx.get(urlAtom).href !== href) {
    // do not use `useEffect` to prevent race conditions (`urlAtom` reading during the render)
    updateFromSource(ctx, new URL(href));
  }
};
